import { action, observable } from 'mobx'
import { moviesBatchDelete } from './entity_confs/films/batch'
import * as defaultConst from '../constants/default_constants'
import * as linkConst from '../constants/link_constants'
import contractItemsConfs from './entity_confs/contractitems/batch_confs'
import flyprivateCategoriesUpdateConfs from './entity_confs/fpv_categories/flyprivate_cats_update'
import flyprivateCatsCopy from './entity_confs/films/FPCatsCopy'
import flyprivateHomeSettingsConfs from './entity_confs/fpv_settings/fpv_settings_batch'
import flyprivateHomeSettingsUpdate from './entity_confs/fpv_settings/fpv_settings_update'
import flyprivatePricingsCopy from './entity_confs/films/FPPricingsCopy'
import flyprivateTestingFilmsConfs from './entity_confs/fpv_testing/flyprivate_testing_films'
import flyprivateTestingGroupConfs from './entity_confs/fpv_testing/flyprivate_testing_group'
import flyprivateTestingPlatformConfs from './entity_confs/fpv_testing/flyprivate_testing_platform'
import flyprivateTestingTiersConfs from './entity_confs/fpv_testing/flyprivate_testing_tiers'
import flyprivateVideoCategoriesConfs from './entity_confs/films/flyprivate_cats'
import flyprivateVideoPricingConfs from './entity_confs/films/flyprivate_pricing'
import flyprivateTesterConfs from './entity_confs/fpv_testing/flyprivate_testing_tester'

import { extendMoment } from 'moment-range'
import Moment from 'moment'
const moment = extendMoment(Moment)

export default (BaseClass) => class BatchOpsState extends BaseClass {
  showBatchEdit (operation, entityname, ids) {
    const batchActionEntity = linkConst.BATCH_ACTION_SETUP[operation].subentity
    this.loadEnumOptions('ContractCurrency')
    this.loadEnumOptions('Countries')
    this.loadEnumOptions('FlyPrivatePlatforms')
    this.loadEnumOptions('FlyprivateCategories')
    this.loadEnumOptions('PricingTiers')
    this.loadEnumOptions('TestingGroups')
    this.loadEnumOptions('TimeZones')
    this.loadEnumOptions('VodSaleTypes')
    this.loadOptions(linkConst.LOAD_OPTIONS.contracts)
    this.loadOptions(linkConst.LOAD_OPTIONS.films)
    this.loadOptions(linkConst.LOAD_OPTIONS.filmcargo_help)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_all_pricings)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_all_tiers)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_all_video_pricings)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_categories_settings)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_homepage_settings)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_pricings)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_testing)
    this.loadOptions(linkConst.LOAD_OPTIONS.rating)
    this.loadOptions(linkConst.LOAD_OPTIONS.timeZonesList)
    this.loadOptions(linkConst.LOAD_OPTIONS.uploads)

    this.cv = observable({
      title: this.__('batch edit'),
      loading: true,
      overwrite: true,
      ids: ids ? ids.split(',') : null,
      entityname: entityname,
      operation: operation,
      items: [],
      itemsStatus: observable.map({}),
      record: observable.map({}),
      errors: observable.map({}),
      temporary: observable.map({}),
      platformFilter: null,
      subentities: {},
      validators: {
        _global: (vals, errors) => {
        }
      }
    })
    this.cv.record.set(batchActionEntity, [])

    switch (operation) {
    case linkConst.BATCH_ACTION_PRICING:
      this.cv.subentities.FPPricingsCopy = flyprivatePricingsCopy(this)
      this.cv.subentities[batchActionEntity] = flyprivateVideoPricingConfs(this)
      break
    case linkConst.BATCH_ACTION_PRICING_TEMP:
      this.cv.subentities[batchActionEntity] = flyprivateVideoPricingConfs(this)
      break
    case linkConst.BATCH_ACTION_CATEGORIES:
      this.cv.subentities.FPCatsCopy = flyprivateCatsCopy(this)
      this.cv.subentities[batchActionEntity] = flyprivateVideoCategoriesConfs(this)
      break
    case linkConst.BATCH_ACTION_CATEGORIES_UPDATE:
      this.cv.subentities[batchActionEntity] = flyprivateCategoriesUpdateConfs(this)
      break
    case linkConst.BATCH_ACTION_CONTRACT:
      this.cv.subentities[batchActionEntity] = contractItemsConfs(this)
      break
    case linkConst.BATCH_ACTION_TESTING1:
      this.cv.subentities[batchActionEntity] = flyprivateTestingFilmsConfs(this)
      break
    case linkConst.BATCH_ACTION_TESTING2:
      this.cv.subentities[batchActionEntity] = flyprivateTestingTiersConfs(this)
      break
    case linkConst.BATCH_ACTION_TESTING3:
      this.cv.subentities[batchActionEntity] = flyprivateTestingPlatformConfs(this)
      break
    case linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING:
      this.cv.subentities[batchActionEntity] = flyprivateTesterConfs(this)
      break
    case linkConst.BATCH_ACTION_SETGROUP:
      this.cv.subentities[batchActionEntity] = flyprivateTestingGroupConfs(this)
      break
    case linkConst.BATCH_ACTION_FPVHOMEPAGE:
      this.cv.subentities[batchActionEntity] = flyprivateHomeSettingsConfs(this)
      break
    case linkConst.BATCH_ACTION_FPVHOMEPAGE_UPDATE:
      this.cv.subentities[batchActionEntity] = flyprivateHomeSettingsUpdate(this)
      break
    }

    this.onClickDisable(false)
    this.loadEntities()
  }

  loadEntities () {
    const timestamp = ((new Date()).getTime() / 1000)
    Promise.all(this.cv.ids.map((i, idx) => {
      return this.requester.getEntry(this.cv.entityname, i).then((result) => {
        const timestampIdx = moment.unix(timestamp).add(idx, 'second').format('YYYY-MM-DD HH:mm:ss')
        result.updated_order = timestampIdx
        result.batch_order = idx
        this.cv.items.push(result)
        this.cv.itemsStatus.set(result.id, defaultConst.STATUS_SELECTED)
      }).catch(this.onRequesterError.bind(this))
    }))
      .then(() => {
        this.cv.loading = false
      })
  }

  @action gotoBatch (operation) {
    this.lastUsedSelection = this.cv.selection
    const ids = this.cv.selection.map((i) => {
      return this.cv.items[i][this.cv.pkName || 'id']
    })
    this.router.goTo(this.views.batch_edit, {
      operation,
      entityname: this.router.params.entityname
    }, this, { ids: ids.join(',') })
  }

  batchDelete () {
    // check if entity is film
    if (this.router.params.entityname === 'films') {
      return moviesBatchDelete(this).then(() => {
        this.markDirty('films')
        this.markDirty('films_parent_id')
        this.markDirty('seasons')
        this.markDirty('episodes')
        return true
      }).catch(this.onRequesterError.bind(this))
    } else {
      // other entities
      if (confirm(this.__('Are you sure you want to delete selected items?'))) {
        this.cv.deleteSelected().then(() => {
          this.markDirty(this.router.params.entityname)
          this.addMessage(this.__('Selected items deleted'))
        }).catch(this.onRequesterError.bind(this))
      }
    }
  }

  @action async batchSave (mode) {
    this.onClickDisable(true)

    const batchActionEntity = this.cv.operation === linkConst.BATCH_ACTION_TESTING3
      ? linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity
      : linkConst.BATCH_ACTION_SETUP[this.cv.operation].subentity

    const setUpdate = new Promise(resolve => {
      this.cv.items.filter(i => this.cv.itemsStatus.get(i.id) !== defaultConst.STATUS_SAVED).map(i => {
        this.cv.itemsStatus.set(i.id, defaultConst.STATUS_UPDATING)
      })
      setTimeout(() => resolve(), 1)
    })
    await setUpdate

    const resolvedAll = promises => {
      Promise.all(promises).then((result) => {
        this.cv.record.clear()
        this.cv.record.set(this.cv.operation === linkConst.BATCH_ACTION_TESTING3
          ? linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING3].subentity
          : batchActionEntity, [])

        if (result.find(v => v === false) === false) {
          this.addMessage(this.__('Selected items finished with the validation error.'), 'error', 5000)
        } else {
          this.addMessage(this.__('All selected items that passed validation had been saved.'), 'success', 3000)
        }
        this.onClickDisable(false)
      })
        .catch(this.onRequesterError.bind(this))
    }

    const saveItem = (promise, item) => {
      item.batch_mode = mode
      return promise.then((result) => {
        return this.cv.itemsStatus.set(item.id, defaultConst.STATUS_SAVED)
      })
        .catch(() => this.cv.itemsStatus.set(item.id, defaultConst.STATUS_ERROR))
        .catch(this.onRequesterError.bind(this))
    }

    const delayPromise = (i = 1, t = 100) => new Promise(resolve => {
      return setTimeout(resolve, i * t)
    })

    const passValidators = (item, isTesting = false) => {
      const passedArray = []
      const loopAll = (validator) => {
        if (item[batchActionEntity] && item[batchActionEntity].length > 1) {
          item[batchActionEntity].map((values) => {
            passedArray.push(validator(values, item[batchActionEntity], true))
          })
        } else {
          return true
        }
        const passed = passedArray.every(v => v === undefined)
        return passed ? true : passedArray
        // return if everything in current item passed validations, if do not than validation fails
      }
      return isTesting
        ? true // not validate
        : loopAll(this.cv.subentities[batchActionEntity].validators._global) // to validate
    }

    const countires = this.options.get('Countries')
    const getRegions = (regions) => {
      if (!regions || !regions.length) {
        return ['']
      } else if (regions === 'WW' || regions.split(',').includes('WW')) {
        return ['WW']
      }
      const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
      return regions.charAt(0) === '-'
        ? countires.map(country => !splitRegions
          .find(region => region === country.value) && country.value)
          .filter(result => result && result.length <= 2)
        : splitRegions
    }

    //
    // Set of special conditions:
    //
    // console.log(batchActionEntity)

    // BATCH_ACTION_UPLOAD_ARCHIVE
    if (mode === 'uploadarchive' && batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_UPLOAD_ARCHIVE].subentity) {
      const toMove = []
      this.cv.items.map(i => {
        const founds = this.options.get('uploads')
          .filter(f => parseInt(f.video_id) === parseInt(i.id) &&
            f.state === 'encoded' &&
            // (moment().isBefore(moment(f.valid_from)) || moment().isAfter(moment(f.valid_to))) &&
            defaultConst.VIDEO_TYPES.indexOf(f.file_type) >= 0)

        if (founds && founds.length > 0) {
          toMove.push(...founds)
        } else {
          this.cv.itemsStatus.set(i.id, defaultConst.STATUS_UPDATED)
        }
      })

    Promise.all(toMove.map((upload, itemidx) => new Promise(resolve => {
      this.cv.itemsStatus.set(upload.video_id, defaultConst.STATUS_UPDATING)
      new Promise(resolve => setTimeout(resolve, itemidx * 500))
        .then(_ => {
          const s3path = upload.file_type + '/' + (upload.s3_filename && upload.s3_filename.indexOf('/') > 1
            ? upload.s3_filename.substr(0, upload.s3_filename.indexOf('/'))
            : upload.s3_filename)
          return this.requester.call('/uploads/archiveAsset', 'post', { id: upload.id, path: s3path })
        })
        .then(_ => {
          this.cv.itemsStatus.set(upload.video_id, defaultConst.STATUS_SAVED)
        })
        .then(() => resolve())
        .catch(err => {
          this.cv.itemsStatus.set(upload.video_id, defaultConst.STATUS_ARCHIVING_ERROR)
          console.log(err);
          resolve(false)
        })
      }))).then((result) => {
        if (result.find(v => v === false) === false) {
          this.addMessage(this.__('Some files finished with an error'), 'error', 5000)
        } else {
          this.addMessage(this.__('All files had been moved'), 'success', 3000)
        }
        this.onClickDisable(false)
      })

    // BATCH_ACTION_SETINACTIVE
     } else if (mode === 'setAsInactive' && batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETINACTIVE].subentity) {
      const record = Object.fromEntries(this.cv.record)

      if (!record.setinactive_type_selected) {
        alert('Select what type of items should be affected!')
        return false
      }

      const alowedPricingIds = record.setinactive_type_selected === 'pricings'
        ? this.options.get('flyprivate_pricings')
          .filter(p => {
            if (record.pricing_select_platform && p.platform !== record.pricing_select_platform) { return false }
            if (record.pricing_select_type && p.type_sale !== record.pricing_select_type) { return false }
            if (record.pricing_select_tier && p.tier !== record.pricing_select_tier) { return false }
            return true
          }).map(p => p.id)
        : []
      const alowedCategory = record.setinactive_type_selected === 'categories' && record.category_selected
        ? record.category_selected
        : ''
      const alowedPlatform = record.setinactive_type_selected === 'categories' && record.platform_selected
        ? record.platform_selected.toLowerCase()
        : ''
      const toInactive = record.setinactive_type_selected === 'pricings'
        ? 'flyprivate_video_pricing'
        : 'flyprivateCategories'

      if (!window.confirm('Are you sure you want to set all records as inactive?')) { return }

      resolvedAll(this.cv.items.map(item => {
        const newItems = []

        const sRegions = record.region_selected
          ? getRegions(record.region_selected)
          : null

        const validToRestriction = record.setinactive_type_selected === 'pricings'
          ? (this.timeRestriction ? this.timeRestriction.flyprivate_video_pricing.valid_to.minDate : moment())
          : (this.timeRestriction ? this.timeRestriction.flyprivateCategories.valid_to.minDate : moment())
        const validToSelected = (this.cv.record.has('new_valid_to') && this.cv.record.get('new_valid_to'))
          ? moment(this.cv.record.get('new_valid_to'))
          : validToRestriction
        const inactiveDay = validToSelected.isSameOrAfter(validToRestriction, 'day')
          ? validToSelected
          : validToRestriction

        item[toInactive].forEach(i => {
          const itemSelected =
            (record.setinactive_type_selected === 'pricings' && alowedPricingIds.includes(i.flyprivate_platform_tier_pricing_id)) ||
            (record.setinactive_type_selected === 'categories' &&
            (i.enum_value === alowedCategory || (!alowedCategory && i.enum_value.toLowerCase().indexOf(alowedPlatform) === 0)))
          const validToOld = i.valid_to
          const continueRegions = []
          const inactiveRegions = sRegions && getRegions(i.regions || []).filter(r => {
            if (sRegions.includes(r)) {
              return true
            } else {
              continueRegions.push(r)
            }
          })

          if (itemSelected &&
            (!sRegions || (inactiveRegions && inactiveRegions.length > 0)) &&
            i.valid_from && moment(i.valid_from).isSameOrBefore(inactiveDay, 'day') &&
            i.valid_to && moment(i.valid_to).isSameOrAfter(inactiveDay, 'day')
          ) {
            i.updated = new Date()
            i.valid_to = (moment(i.valid_to).isAfter(inactiveDay, 'day')
              ? inactiveDay.format(defaultConst.DATE_FORMAT) + defaultConst.DATE_TIME_UTC_END
              : i.valid_to)
            const newValidFrom = moment(i.valid_to).clone().add(1, 'seconds').utc().format()

            // continue with untouched regions
            if (continueRegions && continueRegions.length > 0 && moment(validToOld).isAfter(moment(newValidFrom))) {
              newItems.push(Object.assign({}, i, {
                id: undefined,
                regions: continueRegions.join(','),
                updated: new Date(),
                valid_from: newValidFrom,
                valid_to: validToOld
              }))
            }
            // save after all modifications
            newItems.push(i)
          } else if (itemSelected &&
              i.valid_from && moment(i.valid_from).isAfter(inactiveDay, 'day') &&
              continueRegions && continueRegions.length > 0
          ) {
            // save continueRegions
            i.regions = continueRegions.join(',')
            i.updated = new Date()
            newItems.push(i)
          } else if (!itemSelected || (i.valid_to && moment(i.valid_to).isBefore(inactiveDay, 'day'))) {
            // save untouched
            newItems.push(i)
          }
        })

        item[toInactive] = [...newItems]
        return saveItem(this.requester.saveEntry(
          this.cv.entityname, Object.assign({}, item), item.id), item
        )
      }))

      // BATCH_ACTION_PRICING_TEMP
    } else if (mode === 'pricingTemp' && batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING_TEMP].subentity) {
      const record = Object.fromEntries(this.cv.record).flyprivate_video_pricing[0]
      if (!record || !record.flyprivate_platform_tier_pricing_id) {
        alert('Error! Missing selected pricing.')
        return false
      } else {
        if (!window.confirm('Are you sure you want to set temporary pricing?')) { return }
      }

      const pricingTemp = record.flyprivate_platform_tier_pricing_id &&
        this.options.get('flyprivate_pricings').find(p => p.id === record.flyprivate_platform_tier_pricing_id)

      const isOverlapping = (cStart, cEnd, nStart, nEnd) => {
        const cRange = cStart && cEnd && moment.range(cStart, cEnd)
        const nRange = nStart && nEnd && moment.range(nStart, nEnd)
        return cRange.overlaps(nRange) || nRange.overlaps(cRange) ||
          moment(cStart).format('YYYY-MM-DD') === moment(nEnd).format('YYYY-MM-DD') ||
          moment(nStart).format('YYYY-MM-DD') === moment(cEnd).format('YYYY-MM-DD')
      }

      resolvedAll(this.cv.items.map(film => {
        const newPricings = []
        const itemBackup = [...film[batchActionEntity]]
        const newLeftDate = moment(record.valid_from).subtract(1, 'days').format(defaultConst.DATE_FORMAT)
        const newRightDate = moment(record.valid_to).add(1, 'day').format(defaultConst.DATE_FORMAT)

        film.flyprivate_video_pricing.forEach(i => {
          const pricingCurrent = this.options.get('flyprivate_pricings').find(p => p.id === i.flyprivate_platform_tier_pricing_id)
          const hasPricingCond = record.flyprivate_pricing_to_interrupt
            ? (parseInt(i.flyprivate_platform_tier_pricing_id) === parseInt(record.flyprivate_pricing_to_interrupt))
            : (pricingTemp.platform === pricingCurrent.platform && pricingTemp.type_sale === pricingCurrent.type_sale)

          const missingRegions = []
          const toChangeRegions = []
          if (i.regions !== record.regions) {
            const regionsCurrent = getRegions(i.regions)
            const regionsTemp = getRegions(record.regions)

            regionsCurrent.map(rc => {
              if (rc === 'WW') {
                regionsTemp[0] = '-' + regionsTemp[0]
                missingRegions.concat(regionsTemp)
                toChangeRegions.push(rc)
              } else if (!regionsTemp.includes(rc)) {
                missingRegions.push(rc)
              } else {
                toChangeRegions.push(rc)
              }
            })
          }

          if (hasPricingCond &&
            (toChangeRegions.length > 0 || i.regions === record.regions) &&
            isOverlapping(i.valid_from, i.valid_to, record.valid_from, record.valid_to)
          ) {
            if (moment(i.valid_from).isSameOrAfter(moment(record.valid_from), 'day') &&
              moment(i.valid_to).isSameOrBefore(moment(record.valid_to), 'day')
            ) {
              // skip short pricing
            } else {
              const isBeforeValidFrom = moment(i.valid_from).isBefore(moment(record.valid_from), 'day')
              if (isBeforeValidFrom) {
                newPricings.push(Object.assign({}, i, { updated: new Date(), valid_from: i.valid_from, valid_to: newLeftDate }))
              }
              const isAfterValidTo = moment(i.valid_to).isAfter(moment(record.valid_to), 'day')
              if (isAfterValidTo) {
                newPricings.push(Object.assign({}, i, { id: (!isBeforeValidFrom ? i.id : undefined), updated: new Date(), valid_from: newRightDate, valid_to: i.valid_to }))
              }
            }
            // if missing regions and with new valid_from / valid_to
            if (missingRegions.length > 0) {
              const validFMissing = moment(i.valid_from).isAfter(moment(record.valid_from), 'day') ? i.valid_from : record.valid_from
              const validTMissing = moment(i.valid_to).isBefore(moment(record.valid_to), 'day') ? i.valid_to : record.valid_to
              newPricings.push(Object.assign({}, i, { id: undefined, updated: new Date(), regions: missingRegions.join(','), valid_from: validFMissing, valid_to: validTMissing }))
            }
          } else {
            // return existing pricing if out of conditions
            newPricings.push(i)
          }
        })

        // add "temp" pricing
        newPricings.push(record)

        // final validations
        film.flyprivate_video_pricing = [...newPricings]
        let validatorErrors = ''
        const passValidatorsResult = passValidators(film, false)
        passValidatorsResult !== true && passValidatorsResult.map(val => {
          if (val && val[0]) {
            validatorErrors = validatorErrors + val[0].concat(' ')
          }
        })
        if (validatorErrors) {
          this.cv.itemsStatus.set(film.id, validatorErrors || defaultConst.STATUS_VALIDATION_FAIL)
          film[batchActionEntity] = itemBackup
          return false
        } else {
          // final save
          return saveItem(this.requester.saveEntry(this.cv.entityname, Object.assign({}, film), film.id), film)
        }
      }))

      // BATCH_ACTION_ASSIGN_FOR_TESTING - add films under tester:
    } else if (batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING].subentity) {
      const selectedTesters = this.cv.record.get(linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_ASSIGN_FOR_TESTING].subentity)
      const localStatuses = {}
      Promise.all(selectedTesters.map((tester, itemidx) => new Promise(resolve => {
        const filmsByBatch = []
        this.cv.items.forEach(film => {
          filmsByBatch.push({ slug: film.slug })
          localStatuses[film.id] = localStatuses.hasOwnProperty(film.id) ? localStatuses[film.id] + 1 : 1
          if (localStatuses[film.id] === selectedTesters.length) {
            this.cv.itemsStatus.set(film.id, defaultConst.STATUS_UPDATING)
          }
        })
        tester = this.options.get(linkConst.LINK_FPVTESTING).find(f => f.id === tester.id)
        tester[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity] = filmsByBatch
        tester.batch_mode = mode
        const delay = new Promise(resolve => setTimeout(resolve, itemidx * 2000))
        delay.then(() => saveItem(this.requester.saveEntry(linkConst.LINK_FPVTESTING, tester, tester.id), tester))
          .then(() => resolve()).catch(() => resolve(false))
      }))).then((result) => {
        if (result.find(v => v === false) === false) {
          this.addMessage(this.__('Some items finished with an error'), 'error', 5000)
          this.cv.items.forEach(i => this.cv.itemsStatus.set(i.id, defaultConst.STATUS_FETCH_OR_SAVE_ERROR))
        } else {
          this.addMessage(this.__('All items had been saved'), 'success', 3000)
          this.cv.items.forEach(i => this.cv.itemsStatus.set(i.id, defaultConst.STATUS_SAVED))
        }
        this.onClickDisable(false)
      })

      // BATCH_ACTION_CATEGORIES_UPDATE:
      // BATCH_ACTION_FPVHOMEPAGE_UPDATE:
    } else if (
      batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].subentity ||
      batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_FPVHOMEPAGE_UPDATE].subentity
    ) {
      const updateCats = batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].subentity
      const updateEntityName = updateCats
        ? linkConst.LINK_CATEGORIES
        : linkConst.LINK_SETTINGS
      const dateRestriction = updateCats
        ? this.timeRestriction.flyprivateCategories
        : this.timeRestriction.flyprivate_categories_settings_manip
      const record = updateCats
        ? this.cv.subentities[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES_UPDATE].subentity].record
        : this.cv.subentities[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_FPVHOMEPAGE_UPDATE].subentity].record
      resolvedAll(
        this.cv.items.map(item =>
          new Promise(resolve => {
            this.requester.getEntry(updateEntityName, item.id).then(cat => {
              // after valid_from
              if (moment(cat.valid_from).isAfter(dateRestriction.valid_from.restriction)) {
                const updatedCat = updateCats
                  ? Object.assign(cat, {
                    enum_value: record.get('enum_value') || cat.enum_value,
                    regions: record.get('regions') || cat.regions,
                    valid_from: record.get('valid_from') || cat.valid_from,
                    valid_to: record.get('valid_to') || cat.valid_to
                  })
                  : Object.assign(cat, {
                    fp_platform_code: record.get('fp_platform_code') || cat.fp_platform_code,
                    fp_category_code: record.get('fp_category_code') || cat.fp_category_code,
                    homepage_order: record.get('homepage_order') || cat.homepage_order,
                    regions: record.get('regions') || cat.regions,
                    valid_from: record.get('valid_from') || cat.valid_from,
                    valid_to: record.get('valid_to') || cat.valid_to
                  })
                if (this.cv.subentities[batchActionEntity].validators._global(updatedCat, this.options.get(updateEntityName))) {
                  resolve(this.requester.saveEntry(updateEntityName, updatedCat, cat.id)
                    .then(() => this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_SAVED))
                    .catch(() => this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_FETCH_OR_SAVE_ERROR)))
                } else {
                  resolve(new Promise(resolve => {
                    this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_VALIDATION_FAIL)
                    resolve(false) // error for resolveAll()
                  }))
                }
                // after valid_to
              } else if (moment(cat.valid_to).isAfter(dateRestriction.valid_to.restrictionToday)) {
                const updatedCat = Object.assign(cat, {
                  valid_to: record.get('valid_to') || cat.valid_to
                })
                if (this.cv.subentities[batchActionEntity].validators._global(updatedCat, this.options.get(updateEntityName))) {
                  resolve(this.requester.saveEntry(updateEntityName, updatedCat, cat.id)
                    .then(() => this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_SAVED))
                    .catch(() => this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_FETCH_OR_SAVE_ERROR)))
                } else {
                  resolve(new Promise(resolve => {
                    this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_VALIDATION_FAIL)
                    resolve(false) // error for resolveAll()
                  }))
                }
                //
              } else {
                this.cv.itemsStatus.set(cat.id, defaultConst.STATUS_PAST_TIME_RESTRICTION)
              }
            })
          })
        )
      )

      // contract action BATCH_ACTION_SYNCFILMRATINGS
    } else if (batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SYNCFILMRATINGS].subentity) {
      const promises = this.cv.items.map(item => {
        if (item.imdb_id) {
          this.requester.getEntry(this.cv.entityname, item.id).then(record => {
            if (mode === 'overwrite') {
              record.film_rating = item.film_rating // add everything from item to record
              return this.requester.saveEntry(this.cv.entityname, record, item.id)
                .then(() => this.cv.itemsStatus.set(item.id, defaultConst.STATUS_SAVED))
            } else {
              // if merge
              item.film_rating.forEach(ir => {
                if (!record.film_rating.find(rr => rr.region === ir.region)) {
                  // add missing regions to record
                  // keep old ones
                  record.film_rating.push(ir)
                }
              })
              return this.requester.saveEntry(this.cv.entityname, record, item.id)
                .then(() => this.cv.itemsStatus.set(item.id, defaultConst.STATUS_SAVED))
            }
          }).catch(() => this.cv.itemsStatus.set(item.id, defaultConst.STATUS_FETCH_OR_SAVE_ERROR))
        }
      })
      resolvedAll(promises)

      // BATCH_ACTION_CONTRACT
    } else if (batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CONTRACT].subentity) {
      const contract = this.cv.subentities[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CONTRACT].subentity].record
      const promises = this.cv.items.map((item, idx) => {
        delayPromise(idx).then(_ =>
          this.requester.call(`/contractitems?filter={"film_id":"${item.id}"}`)
            .then(res => {
              const contractitems = res.data && res.data.filter(ci => parseInt(ci.film_id) === parseInt(item.id))
              if (!contractitems.find(ci => parseInt(ci.contract_id) === parseInt(contract.get('contract_id')))) {
                return saveItem(this.requester.call('/contractitems', 'post', {
                  film_id: item.id,
                  title: item.title,
                  contract_id: contract.get('contract_id'),
                  platform_specific_licence_period_flg: contract.get('platform_specific_licence_period_flg') || null,
                  attribute_1: contract.get('attribute_1') || null,
                  attribute_2: contract.get('attribute_2') || null,
                  note: contract.get('note') || null,
                  delivered_date: contract.get('delivered_date') || null
                }), item)
              } else {
                this.cv.itemsStatus.set(item.id, defaultConst.STATUS_VALIDATION_FAIL)
              }
            }).catch(this.onRequesterError.bind(this))
        )
      })
      resolvedAll(promises)

      // set group action BATCH_ACTION_SETGROUP
    } else if (batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETGROUP].subentity) {
      const notSavedItems =
        this.cv.items.filter(i => this.cv.itemsStatus.get(i.id) !== defaultConst.STATUS_SAVED)
      const record = this.cv.subentities[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_SETGROUP].subentity].record
      const promises = notSavedItems.map(item => {
        Object.assign(item, { tester_group_batch: true })
        if (mode === 'overwrite') {
          Object.assign(item, {
            tester_group: record.get('tester_group') || null
          })
        } else {
          if (!item.tester_group) {
            Object.assign(item, {
              tester_group: record.get('tester_group') || null
            })
          } else {
            return this.cv.itemsStatus.set(item.id, defaultConst.STATUS_NO_MERGEABLE)
          }
        }
        return saveItem(this.requester.saveEntry(this.cv.entityname, item, item.id), item)
      })
      resolvedAll(promises)

      // others actions
    } else {
      const filmsByPlatform = this.cv.operation === linkConst.BATCH_ACTION_TESTING3
        ? this.requester.call('/films/view/vLatest_updated_assets?attrs=["slug", "platform", "last_update"]').then((result) => {
          const platform = this.cv.subentities[linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING3].subentity].record.get('platform_id')
          const filmsByPlatform = {}
          let counter = 0
          result.data && result.data.map(film => {
            if (counter < defaultConst.FLYPRIVATE_TESTING_FILMS_LIMIT && !filmsByPlatform[film.slug] &&
              film.platform && (film.platform).indexOf(platform) >= 0) {
              counter++
              filmsByPlatform[film.slug] = {
                slug: film.slug
              }
            }
          })
          this.cv.record.set(
            linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity,
            Object.keys(filmsByPlatform).map(key => filmsByPlatform[key])
          )
        })
        : new Promise((resolve) => { resolve(true) })

      filmsByPlatform.then((result) => {
        const notSavedItems =
          this.cv.items.filter(i => this.cv.itemsStatus.get(i.id) !== defaultConst.STATUS_SAVED)

        const promises = notSavedItems.map((item, itemidx) => {
          const itemBackup = [...item[batchActionEntity]]
          const isTesting = this.cv.operation === linkConst.BATCH_ACTION_TESTING1 ||
            this.cv.operation === linkConst.BATCH_ACTION_TESTING2 ||
            this.cv.operation === linkConst.BATCH_ACTION_TESTING3

          // Assign FP tab into films
          this.cv.items.forEach(i => {
            const platforms = (i.platforms && i.platforms.split('|')) || []

            if (platforms[0] === '' || platforms[0] === defaultConst.PLATFORMS_DEFAULT_VALUE) {
              platforms[0] = defaultConst.PLATFORMS_NAMES.flyprivate
            } else {
              (platforms && platforms.find(p => p === defaultConst.PLATFORMS_NAMES.flyprivate)) ||
                platforms.push(defaultConst.PLATFORMS_NAMES.flyprivate)
            }

            i.platforms = platforms.join('|')
          })

          const subentities = [
            linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING1].subentity,
            linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_TESTING2].subentity
          ]
          subentities.map(val => {
            item[val] && item[val].map(val => {
              const addParam = this.options.get('films').find(i => i.id === val.film_id)
              val.slug = addParam && addParam.slug
            })
            item[val] && item[val].map(val => {
              const addParam = this.options.get('flyprivate_pricings').find(i => i.id === val.tier_id)
              val.tier = addParam && addParam.tier
            })
          })

          // FINAL: remake item by selected mode
          const isPricing = batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_PRICING].subentity
          const isCateg = batchActionEntity === linkConst.BATCH_ACTION_SETUP[linkConst.BATCH_ACTION_CATEGORIES].subentity
          const compare = isPricing ? 'second' : 'day'

          if (isTesting && mode !== 'overwrite' && this.cv.record && this.cv.record.get(batchActionEntity)) {
            (this.cv.record.get(batchActionEntity)).forEach(i => {
              const found = this.cv.operation === linkConst.BATCH_ACTION_TESTING2
                ? item[batchActionEntity].find(j => i.tier_id === j.tier_id)
                : item[batchActionEntity].find(j => i.film_id === j.film_id)
              if (!found || !found.id) {
                item[batchActionEntity].push(i)
              }
            })

            // exception for BATCH_ACTION_CATEGORIES || BATCH_ACTION_PRICING
          } else if (mode === 'overwrite' && (isCateg || isPricing)) {
            const useTimeRestriction = isPricing
              ? this.timeRestriction.flyprivate_video_pricing.valid_from.minDateTimeEnd
              : this.timeRestriction.flyprivateCategories.valid_from.minDate
            // close current items
            const newItems = []
            item[batchActionEntity].forEach(i => {
              i.updated = new Date()
              if (moment(i.valid_from).isSameOrBefore(useTimeRestriction, compare) &&
                moment(i.valid_to).isSameOrAfter(useTimeRestriction, compare)
              ) {
                i.valid_to = useTimeRestriction.format(isPricing
                  ? moment.defaultFormatUtc
                  : defaultConst.DATE_FORMAT)
                newItems.push(i)
              } else if (moment(i.valid_to).isBefore(useTimeRestriction, compare)) {
                newItems.push(i)
              }
            })
            item[batchActionEntity] = [...newItems, ...(this.cv.record && this.cv.record.get(batchActionEntity))]
            // default overwrite
          } else {
            item[batchActionEntity] = (mode === 'overwrite')
              ? this.cv.record && this.cv.record.get(batchActionEntity)
              : [...item[batchActionEntity], ...(this.cv.record && this.cv.record.get(batchActionEntity))]
          }

          // passed validations and not had been saved or not?
          const passValidatorsResult = passValidators(item, isTesting)
          if (this.cv.itemsStatus.get(itemidx) !== defaultConst.STATUS_SAVED && passValidatorsResult === true) {
            if (item.updated_order && item[batchActionEntity]) {
              item[batchActionEntity].map((val, idx) => {
                if (!val.id) {
                  item[batchActionEntity][idx] = Object.assign(
                    {}, val, { updated: item.updated_order }
                  )
                }
              })
            }
            // promises with interval
            const delay = new Promise(resolve =>
              setTimeout(resolve, itemidx * (batchActionEntity.indexOf('_testing_') > 0
                ? 2500
                : (isPricing
                  ? 500
                  : 100)
              )))
            return delay.then(() => saveItem(this.requester.saveEntry(this.cv.entityname, item, item.id), item))
            // --
          } else {
            let validatorErrors = ''
            passValidatorsResult.map(val => {
              if (val && val[0]) {
                validatorErrors = validatorErrors + val[0].concat(' ')
              }
            })
            this.cv.itemsStatus.set(item.id, validatorErrors || defaultConst.STATUS_VALIDATION_FAIL)
            item[batchActionEntity] = itemBackup
            return false
          }
        })

        resolvedAll(promises)
      })
        .catch(this.onRequesterError.bind(this))
    }
  }
}
